/* eslint-disable max-lines */

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}

export const enum PLAN_TYPES {
  PURCHASE = 'purchase',
  UPSELL = 'upsell',
  CANCEL_OFFER = 'cancelOffer',
  ONE_TIME = 'one_time',
  SECONDARY = 'secondary',
}

export const enum PLAN_TAGS {
  CANCEL = 'cancel',
  NO_TAX = 'no_tax',
  UPSELL = 'upsell',
  INVOXIA = 'invoxia',
  AB = 'ab',
  VC = 'vc',
  WW = 'ww',
  US = 'us',
  GB = 'gb',
  AU = 'au',
  BR = 'br',
  TEST_B = 'test_b',
  TEST_C = 'test_c',
}

export const enum MediaBreakpoint {
  MIN_PHONE = 321,
  MEDIUM_PHONE = 360,
  MAX_PHONE = 415,
  SALES_SCREEN_MAX_PHONE = 431,
  SALES_SCREEN_MIN_PHONE = 430,
  TABLET = 520,
  PHONE_WITH_390_MIN = 390,
  PHONE_WITH_390_MAX = 389,
  QUESTIONS_DESKTOP = 600,
  DESKTOP = 1024,
}

export const enum StripeFieldName {
  NAME = 'name',
  NUMBER = 'cardNumber',
  EXPIRY = 'cardExpiry',
  CVC = 'cardCvc',
  EMAIL = 'email',
}

export const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const enum LoginMethod {
  EMAIL = 'email',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}

export const enum LoginMethodRaw {
  EMAIL = 'password',
  GOOGLE = 'google.com',
  FACEBOOK = 'facebook.com',
  APPLE = 'apple.com',
}

export const LOGIN_METHOD_RAW_MAP = {
  [LoginMethodRaw.EMAIL]: LoginMethod.EMAIL,
  [LoginMethodRaw.GOOGLE]: LoginMethod.GOOGLE,
  [LoginMethodRaw.FACEBOOK]: LoginMethod.FACEBOOK,
  [LoginMethodRaw.APPLE]: LoginMethod.APPLE,
}

export const enum FirebaseSignUpErrorCode {
  EMAIL_EXISTS = 'auth/email-already-in-use',
}

export const AMPLITUDE_API_KEY = '7c5616a3d04052c3bbe80896ac80c6d0'
export const AMPLITUDE_API_KEY_WOOFY = '126818b858ce26303e057f50bb944180'

export const enum ValidationText {
  EMAIL_EXISTS = 'account.accountAlreadyExist',
  INVALID_EMAIL = 'onboarding.email.validation',
  INVALID_EMAIL_VARIANT_2 = 'onboarding.email.validationTypo',
  EMPTY_EMAIL_ERROR = 'onboarding.email.validation2',
  SHORT_PASSWORD = 'account.shortPassword',
  WRONG_CONFIRMATION_PASSWORD = 'account.notEqualPassword',
  WRONG_PASSWORD = 'The password you entered is incorrect',
  WRONG_EMAIL = 'The email you entered is incorrect',
  INVALID_TEXT = `Your input doesn't look valid. Please, check`,
}

export const enum Color {
  ERROR_RGB = '255, 97, 97',
  PRIMARY_TEXT_RGB = '74, 53, 50',
  MEDIUM_GREEN_RGB = '53, 180, 63',
  PURPLE_RGB = '120, 121, 241',
  ERROR = '#FF6161',
  BG_MAIN = '#F4E8DE',
  BEIGE = '#FFF5E9',
  BEIGE_LIGHT = '#FFF6EF',
  BEIGE_ALTERNATIVE = '#F7F6F1',
  GREYISH_BROWN = '#E5E5E5',
  BG_GRAY = '#F2F2F2',
  WHITE = '#FFFFFF',
  SMOKE_WHITE = '#F5F5F5',
  BROWNISH_GRAY = '#B0A099',
  BROWN_FADE = '#7D6B66',
  PRIMARY_TEXT = '#4A3532',
  PRIMARY_TEXT_SHADOW = '#4A3532CC',
  COLD_GREEN = '#4bab77',
  MEDIUM_GREEN = '#35B43F',
  LIGHT_MOSS_GREEN = '#94CE8E',
  YELLOW_ORANGE = '#F8B900',
  YELLOW_LIGHT = '#FFF192',
  YELLOW = '#F1C73D',
  POWDERY_PINK = '#EA8889',
  PINK = '#F19FC5',
  PURPLE = '#7879F1',
  VIOLET = '#5B5DE4',
  BLACK = '#000',
  LILAC = '#6136C6',
  DARK_VIOLET = '#4A23A5',
  GREY_FIELD_INPUT = '#FFFAF7',
  DARK_PURPLE = '#854eb3',
  GREY_TEXT = '#848484',
  VIOLET_ALTERNATIVE = '#F1F0FF',
  VIOLET_SECONDARY = '#978FFF',
  DARK_GREEN = '#137230',
  BLACK_SECONDARY = '#1E201F',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  RUDDERSTACK = 'rudderstack',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const enum AppWithInAppBrowser {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
}

export const enum PagePath {
  LOCALHOST = 'localhost',
  TUTORIAL = 'tutorial',
  SUBSCRIPTIONS = 'subscriptions',
}

export const enum AnswerKey {
  CLNG_AGE = 'dog_age_clng',
  CLNG_BREED = 'dog_breed_22_v4clng',
  CLNG_BEHAVIOR = 'behavior_clng',
  CLNG_SEX = 'sex_clng',
  WS2_BREED = 'breed_ws2',
  WS2_AGE = 'age_ws2',
  WS2_WALK = 'walk_ws2',
  WS2_SEX = 'sex_ws2',
  WS2_DOG_NAME = 'dog_name_ws2',
  WS2_WORRIES = 'worries_ws2',
  SNRS_SATISFIED = 'satisfied_snrs',
  SNRS_CHALLENGES = 'challenges_snrs',
  SNRS_SEX = 'sex_snrs',
  SNRS_AGE = 'dog_age_snrs',
  SNRS_USER_AGE = 'age_snrs',
  SNRS_BREED = 'dog_breed_snrs',
  SNRS_BARKING = 'barking_snrs',
  PN_SEX = 'sex_pn',
  PN_BREED = 'dog_breed_pn',
  PN_AGE = 'dog_age_pn',
  PN_CHALLENGES = 'challenges_pn',
  PN_BARKING = 'barking_pn',
  DOG_BREED = 'dog_breed',
  WELLNESS_BREED = 'wellness_breed',
  GOALS_QUESTION = 'goals_question',
  POINTS_OF_CONCERNS = 'points_of_concern',
  COMMANDS = 'commands',
  TIME = 'time',
  HEALTH_ISSUES = 'health_issues',
  AGE = 'dog_age',
  WELLNESS_AGE = 'wellness_age',
  SEX = 'sex',
  FEELINGS_PN = 'feelings_pn',
  WELLNESS_SEX = 'wellness_sex',
  DOG_NAME = 'dog_name',
  DOG_NAME_LOVE = 'dog_name_love',
  DOG_NAME_LOVE_BL = 'dog_name_love_bl',
  DOG_NAME_ANXT = 'dog_name_anxt',
  DOG_BREED_ANXT = 'dog_breed_anxt',
  BEHAVIORAL_ISSUES_LOVE = 'behavioral_issues_love',
  BEHAVIORAL_ISSUES_LOVE_BL = 'behavioral_issues_love_bl',
  SHELTER = 'shelter',
  WELLNESS_SHELTER = 'wellness_shelter',
  TRAINING_DIFFICULTIES = 'training_difficulties',
  BEHAVIOR = 'behavior',
  WELLNESS_ANXIETY = 'wellness_anxiety',
  DOG_BODY_CONDITION_TITLE = 'dog_body_condition_title',
  DOG_BODY_CONDITION_PERCENT = 'dog_body_condition_percent',
  DOG_ENERGY = 'dog_energy',
  DOG_NEUTERED = 'dog_neutered',
  DOG_IGNORED = 'dog_ignored',
  BREED_KEY = 'breed_key',
  OTHER_DOGS_REACTION = 'other_dogs_reaction',
  BEHAVIOR_RT = 'behavior_rt',
  GOALS_RT = 'goals_rt',
  CHALLENGES_PN = 'challenges_pn',
  BIGGEST_CHALLENGE_PN = 'biggest_challenge_pn',
  INVOXIA_EMAIL = 'invoxia_email',
  INVOXIA_NAME = 'invoxia_name',
  INVOXIA_ADRESS = 'invoxia_adress',
  INVOXIA_PHONE = 'invoxia_phone',
  INVOXIA_STREET = 'invoxia_street',
  INVOXIA_CITY = 'invoxia_city',
  INVOXIA_STATE = 'invoxia_state',
  INVOXIA_POSTAL_CODE = 'invoxia_postal_code',
  LICKING_LOVE = 'licking_love',
  LICKING_LOVE_BL = 'licking_love_bl',
  FEEL_GUILTY_LOVE = 'feel_guilty_love',
  FEEL_GUILTY_LOVE_BL = 'feel_guilty_love_bl',
  YOUR_REACTION_LOVE = 'your_reaction_love',
  YOUR_REACTION_LOVE_BL = 'your_reaction_love_bl',
  SATISFIED_LOVE = 'satisfied_love',
  SATISFIED_LOVE_BL = 'satisfied_love_bl',
  FOLLOWING_ANXT = 'following_anxt',
  LEAVING_ANXT = 'leaving_anxt',
  CHALLENGE_ANXT = 'challenge_anxt',
  BARKING_ANXT = 'barking_anxt',
  FREQUENCY_ANXT = 'frequency_anxt',
  SHELTER_ANXT = 'shelter_anxt',
  SATISFIED_ANXT = 'satisfied_anxt',
  DOG_SIZE = 'dog_size',
  POTTY_V9 = 'potty_v9',
  WALKS_FEEL = 'walks_feel',
  DOG_CALM_DOWN_RT = 'dog_calm_down_rt',
  DOG_AGGRESSIVE_RT = 'dog_aggressive_rt',
  DOG_EXCITEMENTS_TRIGGERS = 'dog_excitements_triggers',
  MAIN_GOAL_RT = 'main_goal_rt',
  NOISES_VGS = 'noises_vgs',
  BARKS_VGS = 'barks_vgs',
  OUT_OF_CONTROL_VGS = 'out_of_control_vgs',
  CALM_DOWN_VGS = 'calm_down_vgs',
  TRIGGERS_VGS = 'triggers_vgs',
  DOG_OFF_AT_HOME_VGS = 'dog_off_at_home_vgs',
  BEHAVIOR_VGS = 'behavior_vgs',
}

export const DEFAULT_COHORT = 'woofz22_v4'
export const VC_COHORT = 'vc_cohort'
export const WEBAPP_COHORT = 'woofz_wa1'
export const APP_NAME = 'woofz'
export const CENTS_IN_DOLLAR = 100
export const INITIAL_PRICE = 0
export const DEFAULT_CURRENCY = 'usd'
export const LANG_QUERY_PARAM = 'lang'
export const INITIAL_LANGUAGE = 'en'

export const DAYS_IN_PERIOD: { [key: string]: number } = {
  [TimeInterval.WEEK]: 7,
  [TimeInterval.MONTH]: 30,
}

export const REMOVED_COHORTS = [
  'woofz1',
  'woofz2',
  'woofz3',
  'woofz4',
  'woofz5',
  'woofz6',
  'woofz7',
  'woofz24',
  'woofz_esd',
  'woofz_barking',
  'woofz_rfnd',
  'woofz_rfnd2',
  'woofz_anxt',
  'woofz_ar',
]

export const ACTIVE_COHORTS = [
  'woofz22_v3',
  'woofz22_v4',
  'woofz22_v4t',
  'woofz22_v4_wt',
  'woofz_ppp',
  'woofz_ppp_bl',
  'woofz_pup',
  'woofz_pup_bl',
  'woofz_pup_wt',
  'woofz_love',
  'woofz_love_bl',
  'woofz_k9',
  'woofz_k9_bl',
  'woofz_k9_bl_1', // OCS testing cohort
  'woofz_k9_bl_2', // OCS testing cohort
  'woofz_k9_bl_3', // OCS testing cohort
  'woofz_k9_drsl',
  'woofz_pt1',
  'woofz_ppp_woofy',
  'woofz_woofy1',
  'woofz_vc6',
  'woofz_invx',
  'woofz_pup_drsl',
  'woofz_coaching',
  'woofz_rt',
  'woofz_vday_65',
  'woofz_vday_70',
  'woofz_vday_75',
  'woofz_vday_80',
  'woofz_hlwn_65',
  'woofz_hlwn_70',
  'woofz_hlwn_75',
  'woofz_hlwn_80',
  'woofz_sub_cnld_70',
  'woofz_ndd',
  'woofz_ndd_65',
  'woofz_ndd_70',
  'woofz_ndd_75',
  'woofz_ndd_80',
  'woofz_offer1_65',
  'woofz_offer1_70',
  'woofz_offer1_75',
  'woofz_offer1_80',
  'woofz_offer2_70',
  'woofz_offer2_75',
  'woofz_s1_6_12',
  'woofz_s2_6_12',
  'woofz_s3_6_12',
  'woofz_npday_65',
  'woofz_npday_70',
  'woofz_npday_75',
  'woofz_npday_80',
  'woofz_xmas_65',
  'woofz_xmas_70',
  'woofz_xmas_80',
  'woofz_wa1',
  'woofz_smd',
  'woofz_smd_bl',
  'woofz_paw_nup',
  'woofz22_v4_bg',
  'woofz_pt1_bg',
  'woofz_k9_bl_bg',
]

export const DIFFICULTIES_OPTIONS_VALUES = {
  RIGHT_TIME: 'rightTime',
  NO_EXPERT_CHECK: 'noExpertCheck',
  DOG_LOSE_MOTIVATION: 'dogLoseMotivation',
  INSTRUCTIONS_COMPLICATED: 'instructionsComplicated',
  NOT_SEE_PROGRESS: 'notSeeProgress',
  NOT_HAVE_ANY: 'notHaveAny',
}

export const COMMANDS_ANALYTICS_IDS_MAP = {
  marker: 'marker_word',
  look: 'Look',
  name: 'Name',
  no: 'No',
  foodLuring: 'Food_Luring',
  stand: 'Stand',
  leaveIt: 'Leave It',
  off: 'Off',
  releaseCue: 'Release_Cue',
  spin: 'Spin',
  hide: 'Hide',
  place: 'Place',
  bunny: 'Bunny',
  bow: 'Bow',
  tellASecret: 'Tell a secret',
  catchAFrisbee: 'Catch a frisbee',
  jumpThroughTheArmCircle: 'Jump Through the Arm Circle',
  dead: 'Dead',
  wipeYourPaws: 'Wipe your paws',
  getMySlippers: 'Get My Slippers',
  walkBetweenYourLegs: 'Walk Between Your Legs',
  fetch: 'Fetch',
  toysInTheBox: 'toys_in_the_box',
  balance: 'Balance Object on Nose',
  shame: 'Shame',
  jumpOnTheBack: 'Jump On the Back',
  jumpIntoArms: 'Jump Into Arms',
  jumpOffAndTurn: 'jump_off_and_turn',
  stay: 'Stay',
  dropIt: 'Drop It',
  rollOver: 'Roll Over',
  down: 'Down',
  come: 'Come',
  sit: 'Sit',
  snake: 'Snake',
  touch: 'Touch',
  kiss: 'Kiss',
  highFive: 'High Five',
  hug: 'Hug',
  takeIt: 'Take It',
  nose: 'Nose',
  come_video_preview: 'come_video_preview',
  sit_video_preview: 'sit_video_preview',
  name_video_preview: 'name_video_preview',
  marker_word_video_preview: 'marker_word_video_preview',
}

export const AdditionalCommands = {
  come: 'come_video_preview',
  sit: 'sit_video_preview',
  name: 'name_video_preview',
  marker: 'marker_word_video_preview',
}

export const COMMANDS_OPTIONS_VALUES = {
  MARKER: 'marker',
  LOOK: 'look',
  NAME: 'name',
  NO: 'no',
  FOOD_LURING: 'foodLuring',
  STAND: 'stand',
  LEAVE: 'leaveIt',
  OFF: 'off',
  RELEASE_CUE: 'releaseCue',
  SPIN: 'spin',
  HIDE: 'hide',
  PLACE: 'place',
  BUNNY: 'bunny',
  BOW: 'bow',
  TELL_SECRET: 'tellASecret',
  CATCH_FRISBEE: 'catchAFrisbee',
  JUMP_THROGH_ARM: 'jumpThroughTheArmCircle',
  DEAD: 'dead',
  WIPE: 'wipeYourPaws',
  SLIPPERS: 'getMySlippers',
  WALK: 'walkBetweenYourLegs',
  FETCH: 'fetch',
  TOYS: 'toysInTheBox',
  BALANCE: 'balance',
  SHAME: 'shame',
  JUMP_ON_BACK: 'jumpOnTheBack',
  JUMP_INTO_ARMS: 'jumpIntoArms',
  JUMP_OFF_AND_TURN: 'jumpOffAndTurn',
  STAY: 'stay',
  DROP: 'dropIt',
  GIVE: 'give',
  ROLL: 'rollOver',
  DOWN: 'down',
  COME: 'come',
  PLAY: 'playDead',
  SIT: 'sit',
  BEG: 'beg',
  NULL: 'null',
  SNAKE: 'snake',
  TOUCH: 'touch',
  KISS: 'kiss',
  FIVE: 'highFive',
  HUG: 'hug',
  TAKE: 'takeIt',
  NOSE: 'nose',
  LOOK_AT_ME: 'lookAtMe',
}

export const SKILLS_OPTIONS_VALUES = {
  NAME: 'name',
  SIT: 'sit',
  COME: 'come',
  STAY: 'stay',
  DOWN: 'down',
  STAND: 'stand',
  LEAVE_IT: 'leave_it',
  HEEL: 'heel',
  DROP_IT: 'drop_it',
  NO: 'no_stop',
  PLACE: 'place',
  FIND_IT: 'find_it',
  TOUCH: 'touch',
  FETCH: 'fetch',
  OFF: 'off',
  TAKE_IT: 'take_it',
  NOSE: 'nose',
  SPIN: 'spin',
  BOW: 'bow',
  SNAKE: 'snake',
  HUG: 'hug',
  BUNNY: 'bunny',
  ROLL_OVER: 'roll_over',
  PLAY_DEAD: 'play_dead',
  HIGH_FIVE: 'high_five',
  TELL_A_SECRET: 'tell_a_secret',
  HIDE: 'hide',
  CATCH_A_FRISBEE: 'catch_a_frisbee',
  JUMP_ON_THE_BACK: 'jump_on_the_back',
  JUMP_INTO_THE_ARMS: 'jump_into_the_arms',
  JUMP_THROUGH_THE_ARM_CIRCLE: 'jump_through_the_arm_circle',
  WIPE_PAWS: 'wipe_paws',
  GET_MY_SLIPPERS: 'get_my_slippers',
  JUMP_OFF_AND_TURN: 'jump_off_and_turn',
  KISS: 'kiss',
}

export const POTTY_OPTIONS = {
  WITHOUT_SCHEDULE: 'withoutSchedule',
  NIGHT: 'night',
  LEFT_ALONE: 'leftAlone',
  TRAINED: 'trained',
}

export const BEHAVIOR_OPTIONS = {
  BARKING: 'barking',
  LEASH_POOLING: 'leashPulling',
  SEPARATION_ANXIETY: 'separationAnxiety',
  CHEWING: 'chewing',
  CHEWING_2: 'chewing_2',
  AGGRESSION: 'aggression',
  BITING: 'biting',
  HOUSE_SOILING: 'houseSoiling',
  DIGGING: 'digging',
  FOOD_STEALING: 'foodStealing',
  CONTROL: 'control',
  POTTING_WITHOUT_SCHEDULE: 'pottingWithoutSchedule',
  EAT_OF_GROUND: 'eatOfGround',
  JUMPING: 'jumping',
  NIPPING: 'nipping',
  HYPER_ENERGY: 'hyperEnergy',
  HYPERACTIVITY: 'hyperactivity',
  AGGRESSION_2: 'aggression2',
  BEGGING: 'begging',
  POTTY_ISSUES: 'pottyIssues',
  POTTY_ISSUES_2: 'pottyIssues_2',
  OTHER: 'other',
  LEASH_PULLING: 'leash_pulling',
  SEPARATION_ANXIETY_2: 'separation_anxiety',
  HOUSE_SOILING_2: 'house_soiling',
  FOOD_STEALING_2: 'food_stealing',
  POTTING_WITHOUT_SCHEDULE_2: 'potting_without_schedule',
  EAT_OF_GROUND_2: 'eat_of_ground',
  JUMPING_2: 'jumping_2',
  NIPPING_2: 'nipping',
  HYPER_ENERGY_2: 'hyper_energy',
  HYPERACTIVITY_2: 'hyperactivity',
  EXCESSIVE_BARKING: 'excessive_barking',
  DESTRUCTIVE_BEHAVIOR: 'destructive_behavior',
  POTTY_ISSUES_3: 'potty_issues',
  GROWLING: 'growling',
  EXCESSIVE_ENERGY: 'excessiveEnergy',
  MUCH_ENERGY: 'muchEnergy',
  WALKING_ISSUES: 'walking_issues',
  REACTIVITY_TO_DOGS_PEOPLE: 'reactivityToDogsPeople',
  RESTLESSNESS_ANXIETY: 'restlessnessAnxiety',
  HOME_SETUP: 'homeSetup',
  COMMAND_TRAINING: 'commandTraining',
  BUILD_BOND_TRUST: 'buildBondTrust',
  ANXIETY_WHEN_ALONE: 'anxietyWhenAlone',
  POTTY_TRAINING: 'pottyTraining',
  COMING_WHEN_I_CALL: 'comingWhenICall',
  DIET_NUTRITION: 'dietNutrition',
  MEMORY_CONFUSION_ISSUES: 'memoryConfusionIssues',
  FOOD_TOY_GUARDING: 'foodToyGuarding',
  HANDLING_GROOMING_ANXIETY: 'handlingGroomingAnxiety',
  CHASING_MOVING_THINGS: 'chasingMovingThings',
  REACTIVITY: 'reactivity',
  POTTY_ACCIDENTS: 'pottyAccidents_2',
  BITTING_NIPPING: 'bittingNipping',
  DESTRUCTIVE_CHEWING: 'destructiveChewing',
  BARKING_DOG: 'barkingDog',
  POTTY_ISSUES_PT: 'potty_issues',
}

export const HELP_OPTIONS = {
  BASIC_OBEDIENCE: 'basicObedience',
  HOUSEBREAKING: 'housebreaking',
  REDUCING_STRESS: 'reducingStress',
  LEASH_MANNER: 'leashManner',
  BETTER_RECALL: 'betterRecall',
  SOCIALIZATION: 'socialization',
  REDUCING_AGGRESSION: 'reducingAggression',
  REDUCING_BARKING: 'reducingBarking',
  MANAGING_HYPERACTIVITY: 'managingHyperactivity',
  STOPPING_CHEWING: 'stoppingChewing',
  OTHER: 'other',
}

export const REASON_TO_GET_A_DOG = {
  COMPANION: 'companion',
  EMOTIONAL_SUPPORT: 'emotional_training',
  FAMILY: 'family',
  SECURITY: 'security',
  RESCUE_A_DOG: 'rescue_a_dog',
  COMPANION_FOR_A_DOG: 'companion_for_a_dog',
  OTHER: 'other',
}

export const DOG_ROLE = {
  FRIEND: 'friend',
  EMOTIONAL_SUPPORT: 'emotional_training',
  FAMILY: 'family',
  GUARD: 'guard',
  OUTDOOR_BUDDY: 'rescue_a_dog',
  OTHER: 'other',
}

export const SEX_OPTIONS = {
  GIRL: 'girl',
  BOY: 'boy',
}
export const CONCERN_OPTIONS_VALUES = {
  CHEWING: 'chewing',
  BARKING: 'barking',
  DIGGING: 'digging',
  FOOD_STEALING: 'foodStealing',
  BITING: 'biting',
  PULING_ON_LEASH: 'pulingLeash',
  SEPARATION_ANXIETY: 'separationAnxiety',
  POTTY_TRAINING: 'pottyTraining',
  SOCIALIZATION: 'socialization',
  BASIC_DISOBEDIENCE: 'basicDisobedience',
  NIPPING: 'nipping',
  WALKING_ISSUES: 'walkingIssues',
  HOME_DESTRUCTION: 'homeDestruction',
  JUMPING: 'jumping',
  REACTIVITY: 'reactivity',
  AGGRESSION: 'aggression',
  SLEEP_DISORDERS: 'sleepDisorders',
  DISORIENTATION: 'disorientation',
  HOUSE_SOILING: 'houseSoiling',
  LOW_ENERGY: 'lowEnergy',
}

export const GOALS_OPTIONS_VALUES = {
  BEHAVIOUR_PROBLEMS: 'behaviorProblems',
  NEW_TRICKS: 'newTricks',
  DOG_PSYCHOLOGY: 'dogPsychology',
  HOME_ADAPTATION: 'homeAdaptation',
  SEPARATION_ANXIETY: 'separationAnxiety',
  OTHER: 'other',
  FULLY_HOME_TRAINED: 'fullyHomeTrained',
  RAISE_SAFE_DOG: 'raiseSafeDog',
  IMPROVE_BEHAVIOUR: 'improveBehaviour',
  TRICKS: 'tricks',
  PREVENT_PROBLEMS: 'preventProblems',
  GET_STRONG_BOND: 'getStrongBond',
  EXTEND_QUANTITY: 'extendQuantity',
  MAINTAIN_PRESENT_ROUTINE: 'maintainPresentRoutine',
  LEARN_MORE_ABOUT_DOG_NEEDS: 'learnMoreAboutDogNeeds',
  NEW_WAYS_TIME_SPENDING: 'newWaysTimeSpending',
  ADJUST_LIFE_NEW_HOME: 'adjustLifeInNewHome',
  IMPROVE_OBEDIENCE: 'improveObedience',
  LEARN_COMMANDS: 'learnCommands',
  CORRECT_BEHAVIOUR_ISSUES: 'correctIssues',
  IMPROVE_WALKING_BEHAVIOUR: 'walkingBehaviour',
  DECREASE_AGGRESSION: 'decreaseAggression',
  BUILD_STRONG_BOND: 'buildStrongBond',
}

export const TIME_OPTIONS_VALUES = {
  FIVE_TEN_MINUTES: 'fiveTenMinutes',
  TEN_FIFTEEN: 'tenFifteenMinutes',
  TEN_TWENTY_MINUTES: 'tenTwentyMinutes',
  FIFTEEN_TWENTY_MINUTES: 'fifteenTwentyMinutes',
  TWENTY_THIRTY_MINUTES: 'twentyThirtyMinutes',
  MORE_THAN_THIRTY: 'moreThanThirty',
  PLUS_THIRTY: 'plusThirty',
}

export const GENERAL_QUESTIONS_OPTIONS_VALUES = {
  NO: 'no',
  SO_SO: 'soSo',
  YES: 'yes',
  NOT_SURE: 'not sure',
  SOMETIMES: 'sometimes',
}

export const BREED_OPTIONS_VALUES = {
  MIXED_BREED: 'mixedBreed',
  LABRADOR_RETRIEVER: 'labradorRetriever',
  GOLDEN_RETRIEVER: 'goldenRetriever',
  SIBERIAN_HUSKY: 'siberianHusky',
  AMERICAN_PIT_BULL_TERRIER: 'americanPitBullTerrier',
  FRENCH_BULLDOG: 'frenchBulldog',
  GERMAN_SHEPHERD: 'germanShepherd',
  CHIHUAHUA: 'chihuahua',
  YORKSHIRE_TERRIER: 'yorkshireTerrier',
  BORDER_COLLIE: 'borderCollie',
  POODLE: 'poodle',
  BEAGLE: 'beagle',
  SHIH_TZU: 'shihTzu',
  IDK: 'idk',
  OTHER: 'other',
}

export const HEALTH_ISSUES_OPTIONS_VALUES = {
  BUMPS_AND_RASHES: 'bumpsAndRashes',
  RUNNY_EYES_OR_NOSE: 'runnyEyesOrNose',
  SNEEZING_OR_COUGHING: 'sneezingOrCoughing ',
  VOMITING_OR_DIARRHEA: 'vomitingOrDiarrhea',
  SHAKING_HEAD_OR_EARS: 'shakingHeadOrEars',
  NO_ISSUES: 'noIssues',
  VISION: 'vision',
  HEARING: 'hearing',
  JOINTS: 'joints',
  DENTAL: 'dental',
  SKIN: 'skin',
  HEART: 'heart',
  DIGESTION: 'digestion',
  ALLERGIES: 'allergies',
  KIDNEY: 'kidney',
  OBESITY: 'obesity',
  OTHER: 'other',
}

export const DOG_AGE_OPTIONS_VALUES = {
  PUPPY: 'puppy',
  ADOLESCENT: 'adolescent',
  ADULT: 'adult',
  SENIOR: 'senior',
  IDK: 'idk',
}

export const DOG_AGE_STAGE_OPTIONS = {
  ZERO_SIX_MONTH: 'zeroSixMonth',
  YOUNGER_THEN_SIX_MONTH: 'youngerThenSixMonth',
  YOUNGER_THEN_ONE_YEAR: 'youngerThenOneYear',
  SIX_TWELVE_MONTHS: 'sixTwelveMonths',
  SIX_TWELVE_MONTH: 'sixTwelveMonth',
  ONE_TWO_YEAR: 'oneTwoYear',
  TWO_SEVEN_YEARS: 'twoSevenYears',
  MORE_THAN_SEVEN_YEARS: 'moreThanSevenYears',
  MORE_THAN_YEAR: 'moreThanYear',
  MORE_THAN_TWO_YEARS: 'moreThanTwoYears',
  IDK: 'idk',
}

export const AGE_ANSWERS_MAP = {
  [DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_SIX_MONTH]: 'six_months_or_younger',
  [DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTHS]: 'six_to_twelve_months',
  [DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR]: 'one_to_two_years',
  [DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS]: 'two_to_five_years',
  [DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS]: 'seven_years_or_older',
  [DOG_AGE_STAGE_OPTIONS.MORE_THAN_TWO_YEARS]: 'more_than_two_years',
}

export const AGE_OPTIONS_PPP = {
  YOUNGER_THEN_SIX_MONTH: 'youngerThenSixMonth',
  SIX_TWELVE_MONTHS: 'sixTwelveMonths',
  ONE_TWO_YEAR: 'oneTwoYear',
  MORE_THAN_YEAR: 'moreThanYear',
  MORE_THAN_TWO_YEARS: 'moreThanTwoYears',
}

export const USER_ANSWER_TO_MARKUP_MAP: { [key: string]: string } = {
  [TIME_OPTIONS_VALUES.FIVE_TEN_MINUTES]: 'onboarding.time.fiveTenMinutes',
  [TIME_OPTIONS_VALUES.FIFTEEN_TWENTY_MINUTES]:
    'onboarding.time.fifteenTwentyMinutes',
  [TIME_OPTIONS_VALUES.TWENTY_THIRTY_MINUTES]:
    'onboarding.time.twentyThirtyMinutes',
  [TIME_OPTIONS_VALUES.TEN_TWENTY_MINUTES]: 'onboarding.time.tenTwentyMinutes',
  [TIME_OPTIONS_VALUES.MORE_THAN_THIRTY]: 'onboarding.time.moreThanThirty',
  [GOALS_OPTIONS_VALUES.BEHAVIOUR_PROBLEMS]:
    'onboarding.goals.behaviorProblems',
  [GOALS_OPTIONS_VALUES.DOG_PSYCHOLOGY]: 'onboarding.goals.dogPsychology',
  [GOALS_OPTIONS_VALUES.NEW_TRICKS]: 'onboarding.goals.newTricks',
  [GOALS_OPTIONS_VALUES.OTHER]: 'onboarding.goals.other',
  [GOALS_OPTIONS_VALUES.HOME_ADAPTATION]: 'onboarding.goals.homeAdaptation',
  [GOALS_OPTIONS_VALUES.SEPARATION_ANXIETY]:
    'onboarding.goals.separationAnxiety',
  [GOALS_OPTIONS_VALUES.FULLY_HOME_TRAINED]:
    'onboarding.goals.fullyHomeTrained',
  [GOALS_OPTIONS_VALUES.RAISE_SAFE_DOG]: 'onboarding.goals.raiseSafeDog',
  [GOALS_OPTIONS_VALUES.IMPROVE_BEHAVIOUR]: 'onboarding.goals.improveBehaviour',
  [GOALS_OPTIONS_VALUES.TRICKS]: 'onboarding.goals.tricks',
  [GOALS_OPTIONS_VALUES.PREVENT_PROBLEMS]: 'onboarding.goals.preventProblems',
  [GOALS_OPTIONS_VALUES.GET_STRONG_BOND]: 'onboarding.goals.getStrongBond',
  [GOALS_OPTIONS_VALUES.MAINTAIN_PRESENT_ROUTINE]:
    'onboarding.goals.maintainPresentRoutine',
  [GOALS_OPTIONS_VALUES.LEARN_MORE_ABOUT_DOG_NEEDS]:
    'onboarding.goals.learnMoreAboutDogNeeds',
  [GOALS_OPTIONS_VALUES.NEW_WAYS_TIME_SPENDING]:
    'onboarding.goals.newWaysTimeSpending',
  [GOALS_OPTIONS_VALUES.EXTEND_QUANTITY]: 'onboarding.goals.extendQuantity',
  [GOALS_OPTIONS_VALUES.ADJUST_LIFE_NEW_HOME]:
    'onboarding.goals.adjustLifeInNewHome',
  [CONCERN_OPTIONS_VALUES.CHEWING]: 'onboarding.pointsOfConcern.chewing',
  [CONCERN_OPTIONS_VALUES.BARKING]: 'onboarding.pointsOfConcern.barking',
  [CONCERN_OPTIONS_VALUES.BITING]: 'onboarding.pointsOfConcern.biting',
  [CONCERN_OPTIONS_VALUES.DIGGING]: 'onboarding.pointsOfConcern.digging',
  [CONCERN_OPTIONS_VALUES.FOOD_STEALING]:
    'onboarding.pointsOfConcern.foodStealing',
  [CONCERN_OPTIONS_VALUES.PULING_ON_LEASH]:
    'onboarding.pointsOfConcern.pulling',
  [BEHAVIOR_OPTIONS.LEASH_POOLING]: 'onboarding.behavior.leashPulling',
  [BEHAVIOR_OPTIONS.POTTING_WITHOUT_SCHEDULE]:
    'onboarding.behavior.pottingWithoutSchedule',
  [BEHAVIOR_OPTIONS.CONTROL]: 'onboarding.behavior.control',
  [CONCERN_OPTIONS_VALUES.SEPARATION_ANXIETY]:
    'onboarding.pointsOfConcern.separationAnxiety',
  [CONCERN_OPTIONS_VALUES.POTTY_TRAINING]:
    'onboarding.pointsOfConcern.pottyTraining',
  [CONCERN_OPTIONS_VALUES.SOCIALIZATION]:
    'onboarding.pointsOfConcern.socialization',
  [CONCERN_OPTIONS_VALUES.BASIC_DISOBEDIENCE]:
    'onboarding.pointsOfConcern.basicDisobedience',
  [CONCERN_OPTIONS_VALUES.NIPPING]: 'onboarding.pointsOfConcern.nipping',
  [CONCERN_OPTIONS_VALUES.WALKING_ISSUES]:
    'onboarding.pointsOfConcern.walkingIssues',
  [CONCERN_OPTIONS_VALUES.HOME_DESTRUCTION]:
    'onboarding.pointsOfConcern.homeDestruction',
  [CONCERN_OPTIONS_VALUES.JUMPING]: 'onboarding.pointsOfConcern.jumping',
  [CONCERN_OPTIONS_VALUES.REACTIVITY]: 'onboarding.pointsOfConcern.reactivity',
  [CONCERN_OPTIONS_VALUES.AGGRESSION]: 'onboarding.pointsOfConcern.aggression',
  [CONCERN_OPTIONS_VALUES.SLEEP_DISORDERS]:
    'onboarding.pointsOfConcern.sleepDisorders',
  [CONCERN_OPTIONS_VALUES.DISORIENTATION]:
    'onboarding.pointsOfConcern.disorientation',
  [CONCERN_OPTIONS_VALUES.HOUSE_SOILING]:
    'onboarding.pointsOfConcern.houseSoiling',
  [CONCERN_OPTIONS_VALUES.LOW_ENERGY]: 'onboarding.pointsOfConcern.lowEnergy',
  [COMMANDS_OPTIONS_VALUES.BEG]: 'onboarding.commands.beg',
  [COMMANDS_OPTIONS_VALUES.COME]: 'onboarding.commands.come',
  [COMMANDS_OPTIONS_VALUES.DOWN]: 'onboarding.commands.down',
  [COMMANDS_OPTIONS_VALUES.DROP]: 'onboarding.commands.dropIt',
  [COMMANDS_OPTIONS_VALUES.GIVE]: 'onboarding.commands.give',
  [COMMANDS_OPTIONS_VALUES.PLAY]: 'onboarding.commands.playDead',
  [COMMANDS_OPTIONS_VALUES.ROLL]: 'onboarding.commands.rollOver',
  [COMMANDS_OPTIONS_VALUES.SIT]: 'onboarding.commands.sit',
  [COMMANDS_OPTIONS_VALUES.STAY]: 'onboarding.commands.stay',
  [COMMANDS_OPTIONS_VALUES.SNAKE]: 'onboarding.commands.snake',
  [COMMANDS_OPTIONS_VALUES.TOUCH]: 'onboarding.commands.touch',
  [COMMANDS_OPTIONS_VALUES.FIVE]: 'onboarding.commands.highFive',
  [COMMANDS_OPTIONS_VALUES.KISS]: 'onboarding.commands.kiss',
  [COMMANDS_OPTIONS_VALUES.HUG]: 'onboarding.commands.hug',
  [COMMANDS_OPTIONS_VALUES.TAKE]: 'onboarding.commands.takeIt',
  [COMMANDS_OPTIONS_VALUES.NOSE]: 'onboarding.commands.nose',
  [COMMANDS_OPTIONS_VALUES.NULL]: 'onboarding.commands.null',
  [BREED_OPTIONS_VALUES.MIXED_BREED]: 'onboarding.breed.mixedBreed',
  [BREED_OPTIONS_VALUES.LABRADOR_RETRIEVER]:
    'onboarding.breed.labradorRetriever',
  [BREED_OPTIONS_VALUES.GOLDEN_RETRIEVER]: 'onboarding.breed.goldenRetriever',
  [BREED_OPTIONS_VALUES.SIBERIAN_HUSKY]: 'onboarding.breed.siberianHusky',
  [BREED_OPTIONS_VALUES.AMERICAN_PIT_BULL_TERRIER]:
    'onboarding.breed.americanPitBullTerrier',
  [BREED_OPTIONS_VALUES.FRENCH_BULLDOG]: 'onboarding.breed.frenchBulldog',
  [BREED_OPTIONS_VALUES.GERMAN_SHEPHERD]: 'onboarding.breed.germanShepherd',
  [BREED_OPTIONS_VALUES.CHIHUAHUA]: 'onboarding.breed.chihuahua',
  [BREED_OPTIONS_VALUES.YORKSHIRE_TERRIER]: 'onboarding.breed.yorkshireTerrier',
  [BREED_OPTIONS_VALUES.BORDER_COLLIE]: 'onboarding.breed.borderCollie',
  [BREED_OPTIONS_VALUES.POODLE]: 'onboarding.breed.poodle',
  [BREED_OPTIONS_VALUES.BEAGLE]: 'onboarding.breed.beagle',
  [BREED_OPTIONS_VALUES.SHIH_TZU]: 'onboarding.breed.shihTzu',
  [BREED_OPTIONS_VALUES.IDK]: 'onboarding.breed.idk',
  [BREED_OPTIONS_VALUES.OTHER]: 'onboarding.breed.other',
  [HEALTH_ISSUES_OPTIONS_VALUES.BUMPS_AND_RASHES]:
    'onboarding.healthIssues.bumpsAndRashes',
  [HEALTH_ISSUES_OPTIONS_VALUES.RUNNY_EYES_OR_NOSE]:
    'onboarding.healthIssues.runnyEyesOrNose',
  [HEALTH_ISSUES_OPTIONS_VALUES.SNEEZING_OR_COUGHING]:
    'onboarding.healthIssues.sneezingOrCoughing',
  [HEALTH_ISSUES_OPTIONS_VALUES.VOMITING_OR_DIARRHEA]:
    'onboarding.healthIssues.vomitingOrDiarrhea',
  [HEALTH_ISSUES_OPTIONS_VALUES.SHAKING_HEAD_OR_EARS]:
    'onboarding.healthIssues.shakingHeadOrEars',
  [HEALTH_ISSUES_OPTIONS_VALUES.NO_ISSUES]: 'onboarding.healthIssues.noIssues',
  [HEALTH_ISSUES_OPTIONS_VALUES.VISION]: 'onboarding.healthIssues.vision',
  [HEALTH_ISSUES_OPTIONS_VALUES.HEARING]: 'onboarding.healthIssues.hearing',
  [HEALTH_ISSUES_OPTIONS_VALUES.JOINTS]: 'onboarding.healthIssues.joints',
  [HEALTH_ISSUES_OPTIONS_VALUES.DENTAL]: 'onboarding.healthIssues.dental',
  [HEALTH_ISSUES_OPTIONS_VALUES.SKIN]: 'onboarding.healthIssues.skin',
  [HEALTH_ISSUES_OPTIONS_VALUES.HEART]: 'onboarding.healthIssues.heart',
  [HEALTH_ISSUES_OPTIONS_VALUES.DIGESTION]: 'onboarding.healthIssues.digestion',
  [HEALTH_ISSUES_OPTIONS_VALUES.ALLERGIES]: 'onboarding.healthIssues.allergies',
  [HEALTH_ISSUES_OPTIONS_VALUES.KIDNEY]: 'onboarding.healthIssues.kidney',
  [HEALTH_ISSUES_OPTIONS_VALUES.OBESITY]: 'onboarding.healthIssues.obesity',
  [DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_SIX_MONTH]:
    'onboarding.age.youngerThenSixMonth',
  [DOG_AGE_STAGE_OPTIONS.ZERO_SIX_MONTH]: 'onboarding.age.zeroSixMonth',
  [DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTHS]: 'onboarding.age.sixTwelveMonth',
  [DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTH]: 'onboarding.age.sixTwelveMonth',
  [DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR]: 'onboarding.age.oneTwoYear',
  [DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS]: 'onboarding.age.twoSevenYears',
  [DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS]:
    'onboarding.age.moreThanSevenYears',
  [DOG_AGE_STAGE_OPTIONS.IDK]: 'onboarding.age.idk',
  [BEHAVIOR_OPTIONS.LEASH_PULLING]: 'Leash pulling',
  [BEHAVIOR_OPTIONS.SEPARATION_ANXIETY_2]: 'Separation anxiety',
  [BEHAVIOR_OPTIONS.HOUSE_SOILING_2]: 'House soiling',
  [BEHAVIOR_OPTIONS.FOOD_STEALING_2]: 'onboarding.behavior.foodStealing',
  [BEHAVIOR_OPTIONS.POTTING_WITHOUT_SCHEDULE_2]:
    'onboarding.behavior.pottingWithoutSchedule',
  [BEHAVIOR_OPTIONS.EAT_OF_GROUND_2]: 'onboarding.behavior.eatOfGround',
  [BEHAVIOR_OPTIONS.JUMPING_2]: 'onboarding.behavior.jumping',
  [BEHAVIOR_OPTIONS.NIPPING_2]: 'onboarding.behavior.nipping',
  [BEHAVIOR_OPTIONS.HYPER_ENERGY_2]: 'Hyper energy',
  [BEHAVIOR_OPTIONS.HYPERACTIVITY_2]: 'onboarding.behavior.hyperactivity',
  [BEHAVIOR_OPTIONS.EXCESSIVE_BARKING]: 'Excessive barking',
  [BEHAVIOR_OPTIONS.DESTRUCTIVE_BEHAVIOR]: 'Destructive behavior',
  [BEHAVIOR_OPTIONS.POTTY_ISSUES_3]: 'Potty accidents',
  [BEHAVIOR_OPTIONS.GROWLING]: 'Aggression',
  [BEHAVIOR_OPTIONS.WALKING_ISSUES]: 'Walking issues',
}

export const YOUR_DOG = 'your dog'

export const THEMES = {
  VARIANT_1: 'variant_1',
  VARIANT_2: 'variant_2',
  VARIANT_3: 'variant_3',
  VARIANT_4: 'variant_4',
  VARIANT_5: 'variant_5',
  VARIANT_6: 'variant_6',
  VARIANT_VC: 'variant_vc',
  VARIANT_S1: 'variant_s1',
  VARIANT_PT: 'variant_pt',
  VARIANT_HOG: 'variant_hog',
  VARIANT_RT: 'variant_rt',
  URGE: 'urge',
  URGE_MINIMAL: 'urge_minimal',
  VARIANT_V9: 'variant_v9',
  CONGRATS_V9: 'congrats_v9',
  PAYMENT: 'payment',
  VARIANT_WELLNESS: 'variant_wellness',
  VARIANT_LOVE: 'variant_love',
  VARIANT_PN: 'variant_pn',
  VARIANT_SURVEY: 'variant_survey',
  VARIANT_SNRS: 'variant_snrs',
  VARIANT_VGS: 'variant_vgs',
  UPSELL: 'upsell',
  POLICY: 'policy',
}

export const enum CurrentEnvironment {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
  DEV02 = 'dev02',
  STAGE_QA = 'stage-qa',
}

export const TERMS_OF_USE_LINK = 'https://www.woofz.com/terms-of-use/'
export const PRIVACY_POLICY_LINK = 'https://www.woofz.com/privacy-policy/'
export const CONTACT_SUPPORT_LINK = 'https://account.woofz.com/contact-form'
export const CONTACT_SUPPORT_LINK_NEW_SUBS = 'https://www.woofz.com/contact-us/'
export const ACCOUNT_LINK = 'https://account.nove8.com/woofz/login'
export const PRIVACY_POLICY_LINKS = {
  [CurrentEnvironment.DEV]:
    'https://woofzdotcom.supernove8.com/privacy-policy/',
  [CurrentEnvironment.STAGE]:
    'https://woofzdotcom.supernove8.com/privacy-policy/',
  [CurrentEnvironment.PROD]: 'https://www.woofz.com/privacy-policy/',
  [CurrentEnvironment.DEV02]:
    'https://woofzdotcom.supernove8.com/privacy-policy/',
  [CurrentEnvironment.STAGE_QA]:
    'https://woofzdotcom.supernove8.com/privacy-policy/',
}

export const TERMS_OF_USE_LINKS = {
  [CurrentEnvironment.DEV]: 'https://woofzdotcom.supernove8.com/terms-of-use/',
  [CurrentEnvironment.STAGE]:
    'https://woofzdotcom.supernove8.com/terms-of-use/',
  [CurrentEnvironment.PROD]: 'https://www.woofz.com/terms-of-use/',
  [CurrentEnvironment.DEV02]:
    'https://woofzdotcom.supernove8.com/terms-of-use/',
  [CurrentEnvironment.STAGE_QA]:
    'https://woofzdotcom.supernove8.com/terms-of-use/',
}

export const ENV_ADMIN_MAP = {
  [CurrentEnvironment.DEV]: 'woofz.supernove8.com',
  [CurrentEnvironment.STAGE]: 'stage-woofz.nove8.com',
  [CurrentEnvironment.PROD]: 'woofz.nove8.com',
  [CurrentEnvironment.DEV02]: 'woofz.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'stage-woofz.nove8.com',
}

export const ENV_MAP = {
  [CurrentEnvironment.DEV]: 'ws-woofz.supernove8.com',
  [CurrentEnvironment.STAGE]: 'stage-woofz.nove8.com',
  [CurrentEnvironment.PROD]: 'woofz.academy',
  [CurrentEnvironment.DEV02]: 'ws-woofz.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'stage-woofz.nove8.com',
}

export const NOVE8_SUBSCRIPTIONS_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'subscriptions.supernove8.com',
  [CurrentEnvironment.STAGE]: 'subscriptions.meganove8.com',
  [CurrentEnvironment.PROD]: 'subscriptions.nove8.com',
  [CurrentEnvironment.DEV02]: 'subscriptions-dev02.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'subscriptions-qa.meganove8.com',
}

export const NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'VnRTLf6D5hQHNeee8',
  [CurrentEnvironment.STAGE]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.PROD]: 'T4mdUKu0bCF54xkAyb7HslwWLZKkJTVG1',
  [CurrentEnvironment.DEV02]: 'VnRTLf6D5hQHNeee8',
  [CurrentEnvironment.STAGE_QA]: 'QA7KdN3P9MqrstuVXYZ1234ABCDeFgHiJk',
}

export const APP_TO_WEB_API_URL_MAP = {
  [CurrentEnvironment.DEV]: 'purchase.supernove8.com',
  [CurrentEnvironment.STAGE]: 'stage-purchase.nove8.com',
  [CurrentEnvironment.PROD]: 'purchase.nove8.com',
  [CurrentEnvironment.DEV02]: 'purchase.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'stage-purchase.nove8.com',
}

export const USER_SUBSCRIPTION_URL_MAP = {
  [CurrentEnvironment.DEV]: 'account-woofz.gidev.xyz',
  [CurrentEnvironment.STAGE]: 'account-woofz.gistage.com',
  [CurrentEnvironment.PROD]: 'account.woofz.com',
}

export const APP_TO_WEB_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'pvwsH3KPEL5ZCz6RfbvGHnQ4y9fLe3aRio1izYhbPK',
  [CurrentEnvironment.STAGE]: 'pvwsH3KPEL5ZCz6RfbvGHnQ4y9fLe3aRio1izYhbPK',
  [CurrentEnvironment.PROD]: 'pvwp7uRK2dFKh2XNmV5NMh7Co7nAmRnzKBffZTSH0v',
  [CurrentEnvironment.DEV02]: 'pvwsH3KPEL5ZCz6RfbvGHnQ4y9fLe3aRio1izYhbPK',
  [CurrentEnvironment.STAGE_QA]: 'pvwsH3KPEL5ZCz6RfbvGHnQ4y9fLe3aRio1izYhbPK',
}

export const ASSISTANT_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.STAGE]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.PROD]: 'ap-wpM2uEz601jn8MWLc2es5iQ3MVPVgQ3aWb',
  [CurrentEnvironment.DEV02]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.STAGE_QA]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
}

export const ASSISTANT_API_URL_MAP = {
  [CurrentEnvironment.DEV]: 'assistant.supernove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.STAGE]:
    'stage-assistant.nove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.PROD]: 'assistant.nove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.DEV02]: 'assistant.supernove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.STAGE_QA]:
    'stage-assistant.nove8.com/ext/dog-breed/identify',
}

export const RUDDERSTACK_WRITE_KEY_PROD = '2y5zWjhMpL0EmLQ8YwUEvn9kszc'
export const RUDDERSTACK_WRITE_KEY_DEV = '2ygXJ1OXSNmBuVHzMZbGgUOcT1r'
export const RUDDERSTACK_DATA_PLANE_URL = `${window.location.origin}/revents`

export const WOOFZ_CLUB_HOSTNAME = 'woofz.club'

export const TEXT_DIRECTIONS = {
  RTL: 'rtl',
  LTR: 'ltr',
}

export const LOCALES = {
  EN: 'en',
  ES: 'es',
  PT: 'pt',
  FR: 'fr',
  DE: 'de',
  IT: 'it',
  KR: 'kr',
  JP: 'jp',
  PL: 'pl',
  TR: 'tr',
  RO: 'ro',
  ZH: 'zh',
  AR: 'ar',
}

export const enum Locale {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
  FR = 'fr',
  DE = 'de',
  IT = 'it',
  KR = 'kr',
  JP = 'jp',
  PL = 'pl',
  TR = 'tr',
  RO = 'ro',
}

export const SUPPORTED_LOCALES: string[] = [
  LOCALES.EN,
  LOCALES.ES,
  LOCALES.PT,
  LOCALES.FR,
  LOCALES.DE,
  LOCALES.IT,
  LOCALES.KR,
  LOCALES.JP,
  LOCALES.PL,
  LOCALES.TR,
  LOCALES.RO,
  LOCALES.AR,
]

export const enum FirebaseRemoteConfigKey {
  WEB_FUNNELS_CONFIG_FILE = 'web_funnels_config_file',
  ABTEST_BOO_7570_WEB_BILLING = 'abtest_boo_7570_web_billing',
  ABTEST_SUBS_7_NEW_WEB_SUBSCRIPTIONS = 'abtest_subs_7_new_web_subscriptions',
  ABTEST_WEB_1940_FEEDBACK_SCREEN3 = 'abtest_web_1940_feedback_screen3',
  ABTEST_WEB_2166_DISCOUNT_SCREEN4 = 'abtest_web_2166_discount_screen4',
  ABTEST_WEB_2027_COMMITMENT_SCREEN2 = 'abtest_web_2027_commitment_screen2',
  ABTEST_WEB_2370_FIRST_PAGE19 = 'abtest_web_2370_first_page19',
  ABTEST_WEB_2468_FIRST_QUIZ_PART = 'abtest_web_2468_first_quiz_part',
  ABTEST_WEB_2674_ROVER_PARTNERSHIP2 = 'abtest_web_2674_rover_partnership2',
  ABTEST_WEB_2540_FIRST_PAGE21 = 'abtest_web_2540_first_page21',
  ABTEST_WEB_3_WOOFY = 'abtest_web_3_woofy',
  ABTEST_WEB_2592_WOOFY_CHAT_UPSELL = 'abtest_web_2592_woofy_chat_upsell',
  ABTEST_WEB_2747_SUB_PLANS_PW = 'abtest_web_2747_sub_plans_pw',
  ABTEST_WEB_2407_FEEDBACK_SCREEN9 = 'abtest_web_2407_feedback_screen9',
  ABTEST_WEB_2844_SOCIAL_SIGN_UP_K9 = 'abtest_web_2844_social_sign_up_k9',
  ABTEST_WEB_2844_SOCIAL_SIGN_UP_K9_BL = 'abtest_web_2844_social_sign_up_k9_bl',
  ABTEST_WEB_2854_POST_PURCHASE_REDIRECT = 'abtest_web_2854_post_purchase_redirect',
}

export const enum GrowthbookKey {
  ABTEST_WEB_2763_BRAZIL_PR = 'abtest_web_2763_brazil_pr',
  ABTEST_PLT_636_STRIPE_CS = 'abtest_plt_636_stripe_cs',
  ABTEST_WEB_2889_NEW_PAYWALL = 'abtest_web_2889_new_paywall',
  ABTEST_WEB_2901_FINAL_MOTIVATION_SCREEN = 'abtest_web_2901_final_motivation_screen',
  ABTEST_WEB_2867_COMMITMENT_SCREEN3 = 'abtest_web_2867_commitment_screen3',
  ABTEST_WEB_2904_ONE_TIME_UPSELL = 'abtest_web_2904_one_time_upsell',
  ABTEST_WEB_2906_ONE_TIME_UPSELL = 'abtest_web_2906_one_time_upsell',
  ABTEST_WEB_2907_ONE_TIME_UPSELL = 'abtest_web_2907_one_time_upsell',
  ABTEST_WEB_2897_SPIN_WHEEL_HALLOWEEN_PUMPKIN = 'abtest_web_2897_spin_wheel_halloween_pumpkin',
  ABTEST_WEB_2900_SPIN_WHEEL_HALLOWEEN_PUMPKIN_22V4 = 'abtest_web_2900_spin_wheel_halloween_pumpkin_22v4',
}

export const enum TestGroup {
  ABTEST_WEB_1940_B_FEEDBACK_SCREEN3 = 'abtest_web_1940_b_feedback_screen3',
  ABTEST_WEB_2166_B_DISCOUNT_SCREEN4 = 'abtest_web_2166_b_discount_screen4',
  ABTEST_WEB_2264_B_DISCOUNT_SCREEN = 'abtest_web_2264_b_discount_screen',
  ABTEST_WEB_2306_B_FEEDBACK_SCREEN6 = 'abtest_web_2306_b_feedback_screen6',
  ABTEST_WEB_2370_B_FIRST_PAGE19 = 'abtest_web_2370_b_first_page19',
  ABTEST_WEB_2468_B_FIRST_QUIZ_PART = 'abtest_web_2468_b_first_quiz_part',
  ABTEST_WEB_2674_B_ROVER_PROMO = 'abtest_web_2674_b_rover_promo',
  ABTEST_WEB_2540_B_FIRST_PAGE = 'abtest_web_2540_b_first_page',
  ABTEST_WEB_3_B_COACH_FLOW = 'abtest_web_3_b_coach_flow',
  ABTEST_WEB_2592_B_AFTER_ACCOUNT = 'abtest_web_2592_b_after_account',
  ABTEST_WEB_2747_B_SUB_PLANS_PW = 'abtest_web_2747_b_sub_plans_pw',
  ABTEST_WEB_2562_B_CHECKOUT_POPUP = 'abtest_web_2562_b_checkout_popup',
  ABTEST_WEB_2763_B_BRAZIL_PR = 'abtest_web_2763_b_brazil_pr',
  ABTEST_WEB_2407_B_FEEDBACK_SCREEN9 = 'abtest_web_2407_b_feedback_screen9',
  ABTEST_WEB_2844_B_SOCIAL_SIGN_UP = 'abtest_web_2844_b_social_sign_up',
  ABTEST_WEB_2854_B_AUTO_REDIRECT = 'abtest_web_2854_b_auto_redirect',
  ABTEST_WEB_2855_B_SOCIAL_PROOF = 'abtest_web_2855_b_social_proof',
  ABTEST_WEB_2889_B_NEW_PAYWALL = 'abtest_web_2889_b_new_paywall',
  ABTEST_WEB_2867_B_COMMITMENT_SCREEN = 'abtest_web_2867_b_commitment_screen',
  ABTEST_WEB_2904_B_UPSELL_39_99 = 'abtest_web_2904_b_upsell_39.99',
  ABTEST_WEB_2906_B_UPSELL_39_99 = 'abtest_web_2906_b_upsell_39.99',
  ABTEST_WEB_2907_B_UPSELL_39_99 = 'abtest_web_2907_b_upsell_39.99',
  ABTEST_WEB_2897_B_HALLOWEEN_PUMPKIN = 'abtest_web_2897_b_halloween_pumpkin',
  ABTEST_WEB_2900_B_HALLOWEEN_PUMPKIN = 'abtest_web_2900_b_halloween_pumpkin',
  ABTEST_WEB_2901_B_MOTIVATION_SCREEN = 'abtest_web_2901_b_final_motivation_screen',
}

export const DEFAULT_WEB_FUNNELS_CONFIG_FILE = {
  signUpMethods: {
    chooseOtherMethodsShown: true,
    otherMethodsShown: {
      facebook: true,
      apple: true,
      google: true,
    },
  },
  paymentMethodsConfig: {
    paypalMethodShown: true,
    cardMethodShown: true,
    applePayMethodShown: true,
    googlePayMethodShown: true,
  },
  webappRedirectForAndroid: false,
  webappRedirectForIOS: false,
  cloudWatchEvents: false,
  vcEventLink: '',
  allRightsReservedYear: '2025',
  firstScreenBtnText: {
    woofz22: {
      en: 'Get started',
      es: 'Empezar',
      pt: 'Começar',
      fr: 'Commencer',
      de: 'Leg los',
      pl: 'Kontynuuj',
      jp: '続ける',
      kr: '계속',
    },
    woofz22_v2: {
      en: 'Get started',
      es: 'Empezar',
      pt: 'Começar',
      fr: 'Commencer',
      de: 'Leg los',
      pl: 'Kontynuuj',
      jp: '続ける',
      kr: '계속',
    },
    woofz22_v3: {
      en: 'Get started',
      es: 'Empezar',
      pt: 'Começar',
      fr: 'Commencer',
      de: 'Leg los',
      pl: 'Kontynuuj',
      jp: '続ける',
      kr: '계속',
    },
  },
}

export const PDF_BOOK_LINKS = {
  en: 'https://cdn.woofz.academy/Woofz_EN_training_plan.pdf',
  de: 'https://cdn.woofz.academy/Woofz_DE_training_plan.pdf',
  pt: 'https://cdn.woofz.academy/Woofz_PT_training_plan.pdf',
  es: 'https://cdn.woofz.academy/Woofz_ES_training_plan.pdf',
  fr: 'https://cdn.woofz.academy/Woofz_FR_training_plan.pdf',
}

export const PDF_EMOTIONAL_SUPPORT_LINK =
  'https://cdn-prod-unified-content.gismart.xyz/ce453056408feaaf0121c2635933afeb5fcc36b3343ed429f386167d3bb09bbd/Emotional+support+basic+plan.pdf'

export const IDK = 'idk' // idk - i don't know
export const IDK_TRANSLATION_KEY = 'onboarding.age.idk'
export const OTHER_BREED = 'Other Breed'
export const MIXED_BREED = 'Mixed Breed'
export const NONE = 'none'
export const NOTHING = 'nothing'
export const NO_ISSUES = 'No issues'
export const WOOFZ22_TEST_COHORT = 'woofz22_test'
export const WOOFZ22_V3_COHORT = 'woofz22_v3'
export const WOOFZ22_V8_COHORT = 'woofz22_v8'
export const WOOFZ23_V3_COHORT = 'woofz23_v3'
export const WOOFZ_PT = 'woofz_pt1'
export const WOOFZ_HOG = 'woofz_hog'
export const WOOFZ_22_V3_D80 = 'woofz22_v3_d80'
export const WOOFZ_22_V3_D70 = 'woofz22_v3_d70'
export const WOOFZ_22_V5 = 'woofz22_v5'
export const WOOFZ_22_V4 = 'woofz22_v4'
export const WOOFZ_22_V4W = 'woofz22_v4w'
export const WOOFZ_22_V6 = 'woofz22_v6'
export const WOOFZ_RT = 'woofz_rt'
export const WOOFZ_25 = 'woofz25'
export const WOOFZ_OFFER1_65 = 'woofz_offer1_65'
export const WOOFZ_OFFER1_70 = 'woofz_offer1_70'
export const WOOFZ_OFFER1_75 = 'woofz_offer1_75'
export const WOOFZ_OFFER1_80 = 'woofz_offer1_80'
export const WOOFZ_OFFER2_70 = 'woofz_offer2_70'
export const WOOFZ_OFFER2_75 = 'woofz_offer2_75'
export const SUBS_BF_V4 = 'subscriptions_bf_v4'
export const WOOFZ_XMAS_65 = 'woofz_xmas_65'
export const WOOFZ_XMAS_70 = 'woofz_xmas_70'
export const WOOFZ_XMAS_80 = 'woofz_xmas_80'
export const WOOFZ_RFND3 = 'woofz_rfnd3'
export const WOOFZ_RFND3_ND = 'woofz_rfnd3_nd'
export const WOOFZ22_80 = 'woofz22_80'
export const WOOFZ22_V3_HP1 = 'woofz22_v3_hp1'
export const WOOFZ22_V7 = 'woofz22_v7'
export const WOOFZ22_V3_HP2 = 'woofz22_v3_hp2'
export const WOOFZ_VDAY_65 = 'woofz_vday_65'
export const WOOFZ_VDAY_75 = 'woofz_vday_75'
export const WOOFZ_VDAY_80 = 'woofz_vday_80'
export const WOOFZ_VDAY_70 = 'woofz_vday_70'
export const WOOFZ_24 = 'woofz24'
export const WOOFZ_INVX = 'woofz_invx'
export const WOOFZ22_V9 = 'woofz22_v9'
export const WOOFZ_PAYMENT = 'woofz_payment'
export const WOOFZ_NDD = 'woofz_ndd'
export const WOOFZ_NDD_65 = 'woofz_ndd_65'
export const WOOFZ_NDD_70 = 'woofz_ndd_70'
export const WOOFZ_NDD_75 = 'woofz_ndd_75'
export const WOOFZ_NDD_80 = 'woofz_ndd_80'
export const WOOFZ_22_V4L = 'woofz22_v4l'
export const WOOFZ_WS = 'woofz_ws'
export const WOOFZ_SUB_CNLD_70 = 'woofz_sub_cnld_70'
export const WOOFZ_SPRT = 'woofz_sprt'
export const WOOFZ_PPP = 'woofz_ppp'
export const WOOFZ22_V4T = 'woofz22_v4t'
export const WOOFZ_PF = 'woofz_pf1'
export const WOOFZ_LOVE = 'woofz_love'
export const WOOFZ_LOVE_BL = 'woofz_love_bl'
export const WOOFZ_PN = 'woofz_pn'
export const WOOFZ_HLWN_65 = 'woofz_hlwn_65'
export const WOOFZ_HLWN_70 = 'woofz_hlwn_70'
export const WOOFZ_HLWN_75 = 'woofz_hlwn_75'
export const WOOFZ_HLWN_80 = 'woofz_hlwn_80'
export const WOOFZ_SNRS = 'woofz_snrs'
export const WOOFZ22_V4CLNG = 'woofz22_v4clng'
export const WOOFZ_WS2 = 'woofz_ws2'
export const WOOFZ_VGS = 'woofz_vgs'
export const WOOFZ_22_V4ND = 'woofz22_v4nd'
export const WOOFZ_PUP = 'woofz_pup'
export const WOOFZ_WOOFY = 'woofz_woofy1'
export const WOOFZ_22_V9 = 'woofz22_v9'
export const WOOFZ_23_V3 = 'woofz23_v3'
export const WOOFZ_22_TEST = 'woofz22_test'
export const WOOFZ_S1_6_12 = 'woofz_s1_6_12'
export const WOOFZ_S2_6_12 = 'woofz_s2_6_12'
export const WOOFZ_S3_6_12 = 'woofz_s3_6_12'
export const WOOFZ_REVIEW = 'woofz_review'
export const WOOFZ_22_V3_MP = 'woofz22_v3_mp'
export const WOOFZ_17 = 'woofz17'
export const WOOFZ_18 = 'woofz18'
export const WOOFZ_19 = 'woofz19'
export const WOOFZ_20 = 'woofz20'
export const WOOFZ_21 = 'woofz21'

export const GOOGLE_UTM = 'googleadwords_int'
export const CONTACT_FORM_LINK_PROD = 'https://account.woofz.com/contact-form'
export const CONTACT_FORM_LINK_DEV =
  'https://account-woofz.gidev.xyz/contact-form'

export const SAVED_STATE_COHORTS = [
  'woofz22',
  'woofz24',
  'woofz25',
  'woofz22_test',
  'woofz22_v3',
  'woofz22_v2',
  'woofz22_v3_d80',
  'woofz22_v3_d70',
  'fshn_1',
  'woofz_hog',
  'woofz22_v4',
  'woofz_rt',
  'woofz_rfnd3',
  'woofz22_v9',
  'woofz_ppp',
  'woofz_pt1',
  'woofz_ws',
  'woofz22_v4l',
  'woofz22_v4t',
  'woofz_review',
  'woofz22_v4clng',
  'woofz_snrs',
  'woofz22_v4nd',
  'woofz22_v8',
  'woofz_vgs',
]

export const COHORTS_WITH_BREEDS_DROPDOWN = [
  'woofz_pt1',
  'woofz_pf1',
  'woofz_hog',
  'woofz22',
  'woofz24',
  'woofz22_test',
  'woofz22_v3',
  'woofz22_v2',
  'woofz22_v3_d80',
  'woofz22_v3_d70',
  'woofz22_v3_mp',
  'woofz22_v4',
  'woofz22_v5',
  'woofz_vc1',
  'woofz_vc2',
  'woofz_vc3',
  'woofz_vc4',
  'woofz_vc5',
  'woofz_vc6',
  'woofz_rt',
  'woofz22_v9',
  'woofz25',
  'woofz_rfnd3',
  'woofz_ws',
  'woofz22_v4l',
  'woofz_ppp',
]

export const COHORTS_WITH_NEW_DOWNLOAD_SCREEN = [
  WOOFZ22_V3_COHORT,
  WOOFZ_RFND3,
  WOOFZ_22_V9,
  WOOFZ22_V4T,
  WOOFZ_22_V4L,
  WOOFZ_PT,
  WOOFZ_PPP,
  WOOFZ_RT,
  WOOFZ_WS,
  WOOFZ_24,
  WOOFZ_25,
  WOOFZ_SNRS,
  WOOFZ_VGS,
]

export const WEB_APP_API_KEYS = {
  en: 'f57160ad-a043-426f-a314-8fbb20570222',
  es: '9677a0f0-98cf-4a86-9a98-b6a1755ebb41',
  pt: 'ea121635-77f1-46cd-8dac-4136cbca0b54',
  fr: '08e2f831-3862-4576-b3dd-9f1bc7af072b',
  de: '7bfb0fcf-c065-4d28-b098-52514a6a0a91',
  it: 'c53130db-5d38-4577-b517-227294108574',
  pl: '5e10b0a6-c060-430c-9bfe-afe0e4a4fd02',
  jp: 'd4066fa1-1398-4d81-991d-880388ccf915',
  kr: '2d88f7b9-42d5-4e79-943b-67946833b1ed',
}

export const WEBAPP_LINKS = {
  [CurrentEnvironment.DEV]: 'https://app.supernove8.com',
  [CurrentEnvironment.STAGE]: 'https://app.supernove8.com',
  [CurrentEnvironment.PROD]: 'https://app.woofz.com',
  [CurrentEnvironment.DEV02]: 'https://app.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'https://app.supernove8.com',
}

export const enum FLOW {
  WEB = 'web',
  W2W = 'w2w',
}

export const WEB_APP_REDIRECT_URL = {
  [CurrentEnvironment.DEV]: 'https://app.supernove8.com',
  [CurrentEnvironment.STAGE]: 'https://app.supernove8.com',
  [CurrentEnvironment.PROD]: 'https://app.woofz.com',
  [CurrentEnvironment.DEV02]: 'https://app.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'https://app.supernove8.com',
}

export const enum Countries {
  GB = 'GB',
  BR = 'BR',
  CA = 'CA',
  AU = 'AU',
  IT = 'IT',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  US = 'US',
  MX = 'MX',
}

export const CURRENCY = {
  GBP: '£',
  BRL: 'R$',
  CAD: 'C$',
  AUD: 'AU$',
  EUR: '€',
  USD: '$',
}

export const APPLOVIN_PET_AGILITY_EQUIPMENT_CATEGORY_ID = 6983
export const LOGO_IMAGE_URL =
  'https://cdn-prod-unified-content.gismart.xyz/ce453056408feaaf0121c2635933afeb5fcc36b3343ed429f386167d3bb09bbd/logo.png'

export const MANAGE_OPTIONS = {
  EASY: 'easy',
  MANAGEABLE: 'manageable',
  HARD: 'hard',
}

export const enum UtmSourceValues {
  WOOFZWEBSITE = 'woofzwebsite',
  WOOFZWEBSITE_ES = 'woofzwebsite_es',
  RETENO = 'reteno',
}

export const breedIdApiKey = {
  [CurrentEnvironment.DEV]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.STAGE]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.PROD]: 'ap-wpM2uEz601jn8MWLc2es5iQ3MVPVgQ3aWb',
  [CurrentEnvironment.DEV02]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.STAGE_QA]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
}

export const breedIdFetchUrl = {
  [CurrentEnvironment.DEV]: 'assistant.supernove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.STAGE]:
    'stage-assistant.nove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.PROD]: 'assistant.nove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.DEV02]: 'assistant.supernove8.com/ext/dog-breed/identify',
  [CurrentEnvironment.STAGE_QA]:
    'stage-assistant.nove8.com/ext/dog-breed/identify',
}

export const APP_TO_WEB_UNIVERSAL_LINKS = {
  backToApp: 'https://link.woofz.com/on-boarding-paywall',
  redirectWithoutLogin:
    'https://link.woofz.com/on-boarding-paywall?ensure-purchases-synced=true',
  redirectWithLogin: 'https://link.woofz.com/login', // ?token= is required param
} as const

export const APP_TO_WEB_SEARCH_PARAMS = {
  token: 'token', // optional param, firebase token from app
  productId: 'productId', // required param, one of APP_TO_WEB_MOBILE_APP_PRODUCT_IDS
  segmentName: 'segmentName', // required param, one of AppToWebSegmentName
  appsflyerId: 'appsflyerId', // required param, appsflyer id from app
  osVersion: 'osVersion', // required param, os version from app
  countryCode: 'countryCode', // required param, country code from app
  screenName: 'screenName', // required param, screen name from app
}

export const APPLOVIN_UTM_SOURCE = 'applovin_int'
const TIKTOK_UTM_SOURCE_BYTEDANCE = 'bytedance_int'
const TIKTOK_UTM_SOURCE = 'tiktok'
export const TIKTOK_UTM_SOURCE_BYTEDANCEGLOBAL = 'bytedanceglobal_int'
const SNAPCHAT_UTM_SOURCE = 'snapchat_int'
const PINTEREST_UTM_SOURCE = 'pinterest_int'
export const FACEBOOK_UTM_SOURCE = 'facebook_ads'

export const TIKTOK_UTM_SOURCES = [
  TIKTOK_UTM_SOURCE,
  TIKTOK_UTM_SOURCE_BYTEDANCE,
  TIKTOK_UTM_SOURCE_BYTEDANCEGLOBAL,
]

export const LTV_UTM_SOURCES = [
  GOOGLE_UTM,
  APPLOVIN_UTM_SOURCE,
  SNAPCHAT_UTM_SOURCE,
  PINTEREST_UTM_SOURCE,
  FACEBOOK_UTM_SOURCE,
  ...TIKTOK_UTM_SOURCES,
]

export const ZENDESK_CHAT_SNIPPET_URL =
  'https://static.zdassets.com/ekr/snippet.js?key=5fe7073f-e2a7-4ede-a038-aa99092a302c'

export const STRIPE_ERROR_CODES = [
  'insufficient_funds',
  'try_again_later',
  'card_velocity_exceeded',
  'incorrect_cvc',
  'expired_card',
]

export const SUPPORT_EMAIL = 'support@woofz.com'

export const MONTH_PLAN_UNIT = 'month'
export const WEEK_PLAN_UNIT = 'week'
